"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-StatusCollections',
    isLoading: 'c-StatusCollections--IsLoading',
    content: 'c-StatusCollections__Content',
    contentSecond: 'c-StatusCollections__Content__second',
    list: 'c-StatusCollections__List',
    menu: 'c-StatusCollections__Menu'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        width: '600px'
    },
    _a[exports.CSS.isLoading] = {
        display: 'flex',
        'justify-content': 'center'
    },
    _a[exports.CSS.content] = {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-around'
    },
    _a[exports.CSS.contentSecond] = {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-between'
    },
    _a[exports.CSS.list] = {
        'list-style-type': 'none',
        'padding-left': 0
    },
    _a[exports.CSS.menu] = (_b = {
            width: '600px',
            position: 'absolute'
        },
        _b["& .".concat(menu_style_1.CSS.menu)] = {
            right: 'auto',
            width: '100%'
        },
        _b),
    _a);
//# sourceMappingURL=collection.status.modal.style.js.map